module.exports = __webpack_public_path__ + "static/media/ImgMBTI_RPTA.f4694855.png";